<template>
  <div class="wrapper">
    <i class="material-icons align-middle check">check_circle</i>
    <div class="detail-wrapper">
      <div class="title">Thank you for creating a new project!</div>
      <div class="content">
        This <a :href="url" target="_blank">{{ url }}</a> will be your URL, you
        can check for new candidates that we’ll source for you.
      </div>
    </div>
    <div class="close-wrapper" @click="onClose">
      <i class="material-icons align-middle">close</i>
    </div>
  </div>
</template>

<script>
export default {
  props: ["url"],
  methods: {
    onClose: function () {
      this.$emit("onClose");
    },
  },
};
</script>


<style scoped>
.wrapper {
  padding: 20px 60px 20px 24px;
  background: rgba(0, 186, 52, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  position: relative;
}
.check {
  font-size: 48px;
  margin-right: 20px;
  color: #00ba34;
}
.detail-wrapper {
  flex-grow: 1;
}
.title {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  font-family: inter-regular;
  color: #1c1c1c;
}
.content {
  font-size: 16px;
  line-height: 24px;
  color: #585757;
}
.close-wrapper {
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
